import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Context } from "../../Shared/Context/GlobalContext";

const LANGUAGES = [
  {
    code: "es-ES",
    name: "Español",
    flag: "🇪🇸",
    isEmoji: true,
  },
  {
    code: "ca-ES",
    name: "Català",
    flag: "https://upload.wikimedia.org/wikipedia/commons/c/ce/Flag_of_Catalonia.svg",
    isEmoji: false,
  },
  {
    code: "en",
    name: "English",
    flag: "🇬🇧",
    isEmoji: true,
  },
];

const LanguageSelectorPage = () => {
  const { i18n } = useTranslation();
  const { refreshLanguage } = useContext(Context);
  const navigate = useNavigate();

  const handleSelect = (code) => {
    localStorage.removeItem("products");
    localStorage.removeItem("categories");
    i18n.changeLanguage(code);
    refreshLanguage();
    navigate(-1);
  };

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{ minHeight: "60vh", padding: "2rem" }}
    >
      <h4
        className="mb-4 fw-bold"
        style={{
          fontFamily: "var(--tws-font-heading)",
          color: "var(--tws-dark)",
        }}
      >
        {i18n.language === "es-ES"
          ? "Selecciona un idioma"
          : "Selecciona un idioma"}
      </h4>
      <div
        className="d-flex flex-column gap-3"
        style={{ maxWidth: "320px", width: "100%" }}
      >
        {LANGUAGES.map((lang) => (
          <button
            key={lang.code}
            onClick={() => handleSelect(lang.code)}
            className="btn d-flex align-items-center gap-3 p-3 rounded-3"
            style={{
              border:
                i18n.language === lang.code
                  ? "2px solid var(--tws-gold)"
                  : "1px solid var(--tws-border)",
              backgroundColor:
                i18n.language === lang.code
                  ? "var(--tws-muted)"
                  : "var(--tws-white)",
              color: "var(--tws-dark)",
              transition: "var(--tws-transition)",
            }}
          >
            {lang.isEmoji ? (
              <span style={{ fontSize: "2rem", lineHeight: 1 }}>
                {lang.flag}
              </span>
            ) : (
              <img
                src={lang.flag}
                alt={lang.name}
                style={{
                  width: "40px",
                  height: "30px",
                  objectFit: "cover",
                  borderRadius: "4px",
                }}
              />
            )}
            <span
              style={{
                fontSize: "1.1rem",
                fontWeight: i18n.language === lang.code ? 700 : 400,
              }}
            >
              {lang.name}
            </span>
            {i18n.language === lang.code && (
              <span className="ms-auto" style={{ color: "var(--tws-gold)" }}>
                ✓
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageSelectorPage;
